<template>
  <div id="app">
    <Navbar />
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: calc(100vh - 92px);
      "
      v-if="isScreenTooSmall"
      class="alert"
    >
      <p class="text-center" style="font-size: 32pt; color: #20569c">
        <b-icon icon="laptop-fill"></b-icon>
      </p>
      <p
        class="text-center"
        style="font-size: 14pt; font-weight: 500; color: #20569c"
      >
        Maaf, situs ini hanya dapat diakses dalam tampilan desktop. Mohon akses
        situs kami melalui perangkat desktop atau laptop Anda untuk mendapatkan
        pengalaman penuh
      </p>
    </div>
    <Content v-else />
    <Footer />
  </div>
</template>
<script>
import Navbar from "@/components/templates/NavbarSshi2024.vue";
import Content from "@/components/templates/ContentSshi.vue";
import Footer from "@/components/templates/FooterSdiSshi.vue";
export default {
  name: "AppLayout",
  components: {
    Navbar,
    Content,
    Footer,
  },
  data() {
    return {
      isScreenTooSmall: false,
    };
  },
  methods: {
    checkScreenSize() {
      const laptopScreenWidth = 1024;
      this.isScreenTooSmall = window.innerWidth < laptopScreenWidth;
    },
  },
  mounted() {},
  created() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>
